<template>
  <div class="mb-3">
    <a class="d-flex align-items-center gap-2 text-primary fw-semibold" style="cursor:pointer;width:fit-content"
      @click="goBack">
      <i class="bi bi-arrow-left"></i> Back
    </a>
  </div>
  <div class="vendor-evaluation-form">
    <div class="form-sheet">
      <div class="form-title">
        <img :src="companyInfo.logo" alt="Logo" class="form-logo" />
        {{ evalType === 'TRANSPORT' ? 'Form Evaluasi Vendor Transport' : 'Form Evaluasi Supplier' }}
      </div>
  
      <div v-if="loading" class="text-center" style="padding: 20px;">Memuat data...</div>
  
      <template v-else>
        <!-- Header: layout sama Supplier & Transport -->
        <table class="header-table">
          <tbody>
            <tr>
              <td class="label-cell">{{ evalType === 'TRANSPORT' ? 'Nama Vendor' : 'Nama Supplier' }}</td>
              <td class="value-cell">
                <div class="static-value">{{ model.nama_supplier }}</div>
              </td>
              <td class="label-cell" rowspan="4">
                {{ evalType === 'TRANSPORT' ? 'Jenis Vendor' : 'Jenis Supplier' }}
              </td>
              <td class="value-cell checkbox-cell" rowspan="4">
                <!-- SUPPLIER: radio jenis -->
                <template v-if="evalType !== 'TRANSPORT'">
                  <div v-if="isView" class="static-value">{{ jenisSupplierLabel }}</div>
                  <template v-else>
                    <label class="checkbox-row" v-for="opt in options.jenisSupplier" :key="opt.id">
                      <input type="radio" :value="Number(opt.value)" v-model="model.jenis_supplier" />
                      {{ opt.description }}
                      <input v-if="opt.description === 'Lain-lain'" type="text" class="inline-input"
                        v-model="model.jenis_supplier_lainnya"
                        :disabled="Number(model.jenis_supplier) !== Number(opt.value)" />
                    </label>
                  </template>
                </template>
                <!-- TRANSPORT: fixed -->
                <template v-else>
                  <label class="checkbox-row">
                    <input type="radio" :checked="true" disabled />
                    Transportasi
                  </label>
                </template>
              </td>
            </tr>
            <tr>
              <td class="label-cell">
                {{ evalType === 'TRANSPORT' ? 'Jenis Layanan' : 'Jenis Produk/Jasa' }}
              </td>
              <td class="value-cell">
                <template v-if="evalType !== 'TRANSPORT'">
                  <div v-if="isView" class="static-value">{{ jenisProdukJasaLabel }}</div>
                  <select v-else v-model.number="model.jenis_produk_jasa" class="nilai-select" style="width:auto;">
                    <option :value="null" disabled>Pilih</option>
                    <option v-for="opt in options.jenisProdukJasa" :key="opt.id" :value="Number(opt.value)">
                      {{ opt.description }}
                    </option>
                  </select>
                </template>
                <template v-else>
                  <div class="static-value">Angkutan / Transportasi</div>
                </template>
              </td>
            </tr>
            <tr>
              <td class="label-cell">Penilai</td>
              <td class="value-cell">
                <div class="static-value">{{ model.penilai_name || '-' }}</div>
              </td>
            </tr>
            <tr>
              <td class="label-cell">Tanggal</td>
              <td class="value-cell">
                <div v-if="isView" class="static-value">{{ formatDate(model.evaluation_date) }}</div>
                <input v-else v-model="model.evaluation_date" class="plain-input" type="date" />
              </td>
            </tr>
          </tbody>
        </table>
  
        <table class="kesimpulan-table" v-if="isView && model.status_approval === 'REJECTED'">
          <tbody>
            <tr>
              <td style="background:#fdecea;">
                <strong class="rejected-note">Evaluasi ini ditolak</strong>
                <div class="ketentuan-note" style="font-style:normal;color:#1a1a1a;margin-top:6px;">
                  <strong>Alasan penolakan:</strong> {{ model.approver_notes || '-' }}
                </div>
                <div class="ketentuan-note" style="font-style:normal;color:#1a1a1a;">
                  Ditolak oleh {{ model.approver_action_by_name || '-' }}
                  pada {{ formatDate(model.approver_action_on) }}
                </div>
  
                <div class="actions" style="margin-top:12px;">
                  <button class="btn-primary" @click="goToCreateNew">
                    Buat Evaluasi Baru
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
  
        <!-- Tabel penilaian -->
        <table class="evaluation-table">
          <thead>
            <tr>
              <th style="width: 40px">No</th>
              <th>Aspek Penilaian *</th>
              <th>Parameter</th>
              <th style="width: 70px">Nilai</th>
              <th style="width: 260px">Kriteria Penilaian</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(cat, catIndex) in categories" :key="cat.categoryId">
              <tr v-for="(param, paramIndex) in cat.parameters" :key="param.id">
                <td v-if="paramIndex === 0" :rowspan="cat.parameters.length" class="text-center">
                  {{ catIndex + 1 }}
                </td>
                <td v-if="paramIndex === 0" :rowspan="cat.parameters.length" class="aspek-cell">
                  {{ getCategoryLabel(cat) }}
                </td>
                <td class="parameter-cell">
                  <span class="param-letter"></span>{{
                  param.text }}
                </td>
                <td class="text-center">
                  <select v-model.number="model.nilai[param.id]" :disabled="isView" class="nilai-select">
                    <option :value="null" disabled>Pilih</option>
                    <option v-for="n in nilaiScale" :key="n" :value="n">{{ n }}</option>
                  </select>
                </td>
                <td v-if="paramIndex === 0" :rowspan="cat.parameters.length" class="kriteria-cell">
                  <div v-for="k in cat.kriteria" :key="k.nilai">
                    <strong>Nilai {{ k.nilai }}:</strong> {{ k.text }}
                  </div>
                </td>
              </tr>
            </template>
            <tr class="summary-row">
              <td colspan="4">RATA-RATA NILAI</td>
              <td class="summary-value">{{ rataRataDisplay }}</td>
            </tr>
          </tbody>
        </table>
        <table class="kesimpulan-table">
          <tbody>
            <tr>
              <td>
                <strong>Keterangan :</strong>
                <div class="ketentuan-note">
                  *) &nbsp;Setiap aspek penilaian harus disertai/dilampirkan dengan kertas kerja penilaian.
                </div>
                <div v-if="hasAdminCategory" class="ketentuan-note">
                  **) &nbsp;Aspek Kelengkapan Administrasi merupakan dokumen legalitas yang digunakan hanya untuk menilai
                  kinerja Supplier tenaga kerja dan/atau Supplier barang/jasa yang memiliki sertifikasi dan/atau menjalani
                  proses tender dalam hubungan kerja dengan {{ companyInfo.name }} seperti: Kontraktor Bangunan,
                  Supplier
                  Kendaraan, Jasa Konsultan, atau Maintenance Data Center, dll.
                </div>
                <div v-if="hasNdaCategory" class="ketentuan-note">
                  ***) &nbsp;NDA dikhususkan untuk Supplier yang dalam pekerjaannya terdapat risiko pertukaran data namun
                  tidak terbatas pada dokumen legal/pelanggan/keuangan Perusahaan.
                </div>
              </td>
            </tr>
          </tbody>
        </table>
  
        <!-- Kesimpulan otomatis -->
        <table class="kesimpulan-table">
          <tbody>
            <tr>
              <td>
                Kesimpulan:
                <strong v-if="kesimpulanLabel === 'DILANJUTKAN'">Kerjasama Dilanjutkan</strong>
                <strong v-else-if="kesimpulanLabel === 'TIDAK DILANJUTKAN'" class="rejected-note">Kerjasama Tidak
                  Dilanjutkan</strong>
                <span v-else class="text-muted">- (isi semua nilai dulu)</span>
                <div class="ketentuan-note">Ketentuan: Kerjasama dilanjutkan jika rata-rata nilai &ge; {{ threshold }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="kesimpulan-table" v-if="isView">
          <tbody>
            <tr>
              <!-- Catatan -->
              <td style="width:60%; vertical-align:top;">
                <strong>CATATAN :</strong>
  
                <div style="min-height:150px; margin-top:8px;">
                  {{ model.notes || '-' }}
                </div>
              </td>
  
              <!-- Approval -->
              <td style="width:40%; padding:0;">
                <table class="header-table" style="margin:0;">
                  <tbody>
                    <tr>
                      <td class="label-cell text-center">Dinilai Oleh</td>
                      <td class="label-cell text-center">Disetujui Oleh</td>
                    </tr>
  
                    <tr>
                      <td class="text-center">
                        {{ model.penilai_jabatan || 'HRD SPV / PCH SPV' }}
                      </td>
                      <td class="text-center">
                        {{ model.approver_jabatan || 'BO BM / PGAM' }}
                      </td>
                    </tr>
  
                    <tr>
                      <td style="height:90px;"></td>
                      <td></td>
                    </tr>
  
                    <tr>
                      <td>Tanggal : {{ formatDate(model.evaluation_date) }}</td>
                      <td>Tanggal : {{ formatDate(model.approver_action_on) || '-' }}</td>
                    </tr>
                    <tr>
                      <td>Nama : {{ model.penilai_name || '-' }}</td>
                      <td>Nama : {{ model.approver_action_by_name || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="kesimpulan-table" v-if="!isView">
          <tbody>
            <tr>
              <td>
                <strong>Catatan :</strong>
                <textarea v-model="model.notes" class="catatan-textarea" rows="4"
                  placeholder="Tambahkan catatan (opsional)"></textarea>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="kesimpulan-table" v-if="canApprove">
          <tbody>
            <tr>
              <td>
                <strong>Tindakan Approval:</strong>
                <textarea v-model="rejectReasonInput" class="catatan-textarea" rows="3"
                  placeholder="Catatan (wajib diisi kalau menolak, opsional kalau menyetujui)"></textarea>
  
                <div class="actions" style="margin-top:10px;">
                  <button class="btn-primary" @click="handleApprove" :disabled="approving || rejecting">
                    {{ approving ? 'Memproses...' : 'Setujui' }}
                  </button>
                  <button class="btn-secondary" style="color:#b30000;border-color:#b30000;" @click="handleReject"
                    :disabled="approving || rejecting">
                    {{ rejecting ? 'Memproses...' : 'Tolak' }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
  
        <div class="actions" v-if="!isView">
          <button class="btn-primary" @click="handleSave" :disabled="!isFormValid || saving">
            {{ saving ? 'Menyimpan...' : 'Simpan' }}
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import VendorEvaluationForm from './VendorEvaluationForm';
export default VendorEvaluationForm
</script>

<style scoped>
.vendor-evaluation-form {
  max-width: 1000px;
  margin: 0 auto;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 13px;
  color: #1a1a1a;
}

.form-sheet {
  border: 2px solid #000;
  padding: 0;
}

.form-title {
  position: relative;
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  padding: 10px;
  border-bottom: 2px solid #000;
  letter-spacing: 0.5px;
}

.form-logo {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  height: 36px;
  width: auto;
}

.header-table,
.evaluation-table,
.kesimpulan-table,
.signature-table {
  width: 100%;
  border-collapse: collapse;
}

.header-transport .label-cell {
  width: 18%;
  white-space: nowrap;
}

.header-transport .value-cell {
  width: 32%;
}

.header-table td {
  border: 1px solid #000;
  padding: 6px 8px;
  vertical-align: top;
}

.label-cell {
  font-weight: bold;
  background: #f2f2f2;
  white-space: nowrap;
  width: 160px;
}

.value-cell {
  width: 40%;
}

.plain-input {
  width: 100%;
  border: none;
  border-bottom: 1px dotted #999;
  background: transparent;
  padding: 2px 0;
  font-size: 13px;
}

.plain-input:focus {
  outline: none;
  border-bottom: 1px solid #333;
}

.checkbox-cell {
  vertical-align: top;
}

.checkbox-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
  font-weight: normal;
  cursor: pointer;
}

.checkbox-row.inline {
  display: inline-flex;
  margin-right: 24px;
}

.checkbox-row input[type='radio'] {
  appearance: none;
  -webkit-appearance: none;
  width: 13px;
  height: 13px;
  border: 1px solid #000;
  border-radius: 0;
  position: relative;
  margin: 0;
  cursor: pointer;
  flex-shrink: 0;
}

.checkbox-row input[type='radio']:checked {
  background: #000;
}

.checkbox-row input[type='radio']:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.inline-input {
  border: none;
  border-bottom: 1px dotted #999;
  background: transparent;
  font-size: 13px;
  padding: 0 2px;
  flex: 1;
  min-width: 80px;
}

.inline-input:focus {
  outline: none;
  border-bottom: 1px solid #333;
}

.evaluation-table {
  border-top: 2px solid #000;
}

.evaluation-table th {
  border: 1px solid #000;
  background: #e8e8e8;
  padding: 8px 6px;
  font-size: 12px;
  text-align: center;
}

.evaluation-table td {
  border: 1px solid #000;
  padding: 6px 8px;
  vertical-align: top;
}

.text-center {
  text-align: center;
}

.aspek-cell {
  font-weight: bold;
  text-transform: uppercase;
  font-size: 12px;
  text-align: center;
}

.parameter-cell {
  font-size: 12.5px;
}

.param-letter {
  font-weight: bold;
  margin-right: 4px;
}

.nilai-select {
  width: 100%;
  border: 1px solid #999;
  padding: 2px;
  font-size: 13px;
  text-align: center;
}

.kriteria-cell {
  font-size: 11.5px;
  color: #333;
}

.kriteria-cell div+div {
  margin-top: 6px;
}

.summary-row td {
  font-weight: bold;
  background: #f2f2f2;
}

.summary-value {
  background: #000 !important;
  color: #fff;
  text-align: center;
  font-size: 14px;
}

.kesimpulan-table {
  border-top: 2px solid #000;
}

.kesimpulan-table td {
  border: 1px solid #000;
  padding: 8px;
  vertical-align: top;
}

.ketentuan-note {
  margin-top: 6px;
  font-size: 11.5px;
  font-style: italic;
  color: #444;
}

.status-section {
  padding: 10px 4px;
  font-size: 12.5px;
}

.rejected-note {
  color: #b30000;
  font-weight: bold;
}

.signature-table {
  border-top: 2px solid #000;
}

.signature-cell {
  border: 1px solid #000;
  width: 50%;
  padding: 10px;
  vertical-align: top;
}

.signature-title {
  font-weight: bold;
}

.signature-role {
  font-size: 11.5px;
  color: #444;
  margin-bottom: 40px;
}

.signature-space {
  height: 10px;
}

.signature-field {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  font-size: 12.5px;
}

.catatan-textarea {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 6px 8px;
  font-size: 13px;
  font-family: inherit;
  margin-top: 8px;
  resize: vertical;
}

.catatan-textarea:focus {
  outline: none;
  border-color: #1a56db;
}

.actions {
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-primary,
.btn-secondary {
  padding: 8px 20px;
  border-radius: 4px;
  border: none;
  font-size: 13px;
  cursor: pointer;
}

.btn-primary {
  background: #1a56db;
  color: #fff;
}

.btn-primary:disabled {
  background: #9db6e8;
  cursor: not-allowed;
}

.btn-secondary {
  background: #f2f2f2;
  color: #1a1a1a;
  border: 1px solid #ccc;
}
</style>